<template>
  <div id="app">
    <router-view :class="isMobile ? 'mobile-content' : ''" />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapMutations } from 'vuex'
export default {
  beforeCreate() {
    Vue.prototype.$globalHeader = {
      fileUrl: 'https://static.fjtwfw.com'
    }
  },
  data() {
    return {
      isMobile: false
    }
  },
  // computed: {
  //   ...mapState({
  //     isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
  //   })
  // },
  mounted() {
    this.bodyScale()
    window.onresize = () => {
      return (() => {
        this.bodyScale()
      })()
    }
  },
  methods: {
    ...mapMutations(['setIsMobile']), // 假设 mutation 名为 setIsMobile
    updateIsMobile(val) {
      this.setIsMobile(val)
    },
    bodyScale() {
      if (document.documentElement.classList.contains('data-board-fullscreen-active')) {
        const style = document.body.style
        style.zoom = '1'
        style.transform = 'none'
        style.transformOrigin = ''
        style.width = '100%'
        return
      }
      let devicelight = document.documentElement.clientWidth //获取当前分辨率下的可是区域宽度
      let scale = 1 // 分母——设计稿的尺寸
      if (devicelight <= 1000) {
        scale = devicelight / 375
        this.isMobile = true
        this.updateIsMobile(true)
      } else {
        scale = devicelight / 1920
        this.isMobile = false
        this.updateIsMobile(false)
      }

      // 判断各个的浏览器
      const explorer = window.navigator.userAgent
      const allStyle = document.body.style
      if (explorer.indexOf('Firefox') >= 0) {
        // 火狐浏览器
        if (this.isMobile) {
          document.body.style.width = '375px'
        } else {
          document.body.style.width = '1920px'
        }
        document.body.style.transform = `scale(${scale})`
        document.body.style.transformOrigin = 'left top'
      } else {
        allStyle.zoom = scale //放大缩小相应倍数
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  margin: 0;
  padding: 0;
  scrollbar-width: none;
}

body {
  // min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -webkit-text-size-adjust: auto !important;
  text-size-adjust: auto !important;
  -moz-text-size-adjust: auto !important;
  // height: 100%;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 0px !important;
  height: 10px !important;
  // background: 0 0;
  display: none;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  /*background: #fd7286;*/
  transition: color 0.2s ease;
  background: #333;
}
</style>
